import React, { useState } from 'react';
import { CreatePromoter } from './CreatePromoter';
import { StaticPopup } from '../../components/StaticPopup';
import { deleteImage } from '../../redux/staticSlice';
import { useDispatch } from 'react-redux';
import { EmptyPage } from '../EmptyPage';
import { Select } from '../../components/Select';
import { ADVERT_CITY_STORAGE_NAME, createHandlerWithStorage } from '../../helpers/localStorage';
import { getStorageData } from '../../helpers';
import { Input } from '../../components/Input';
import { Button } from '../../components/Button';
import {ReactComponent as Bin} from '../../assets/bin.svg';
// import Bin from '../../assets/bin.svg';


const getKeyStatusProps = (status1, status2) => {
    let s1 = ''
    switch(status1) {
        case -1: {
            s1 = 'Нет'
            break;
        }
        case 0: {
            s1 = 'Залог'
            break;
        }
        case 1: {
            s1 = 'С ЗП'
            break;
        }
        default:
    }
    let s2 = ''
    let color = 'inherit'
    switch(status2) {
        case -1: {
            s2 = ''
            break;
        }
        case 0: {
            s2 = '(У прома)'
            color = '#d4edbc'
            break;
        }
        case 1: {
            s2 = '(В офисе)'
            color = '#bfe1f6'
            break;
        }
        case 2: {
            s2 = '(Вернул)'
            color = '#ffe5a0'
            break;
        }
        case 3: {
            s2 = '(Украл)'
            color = '#b10202'
            break;
        }
        default:
    }
    return {text: `${s1} ${s2}`, color}
}

const PromoterItem = ({data, setEditPromoterPopup}) => {
    const dispatch = useDispatch();
    
    const [docsPopup, setDocsPopup] = useState(false);

    const deleteImageHandler = (type, fileName) => {
        dispatch(deleteImage({ type, name: fileName }));
    };
    const {fullname, documents, id, age, bet} = data;
    const hasDocs = !!documents.length;
    const openDocsPopupHandler = (e) => {
        e.stopPropagation();
        hasDocs && setDocsPopup(true);
    }

    const {text: keyStatusText, color: keyStatusColor} = getKeyStatusProps(data.keyStatus, data.keyStatus2);

    return (<>
        {docsPopup && (
            <StaticPopup
                deleteAccess={true}
                deleteFunc={deleteImageHandler}
                closeFn={() => setDocsPopup(false)}
                content={data.documents.map(n => ({fileName: n, isPhoto: true, type: 'promDoc'}))}
            />
            )}
        <div className="promoters__item promoter-item dark-theme-bg0-hover-bg1" onClick={setEditPromoterPopup}>
            <h3>id{id}. {fullname}</h3>
            <h4>Возраст: {age}</h4>
            <p className={`promoter-item__docs ${!hasDocs ? 'empty' : ''}`} onClick={openDocsPopupHandler}>{hasDocs ? 'Документы' : 'Нет документов'}</p>
            <p>Ставка: {bet}</p>
            <p style={{color: keyStatusColor}}>Ключи: {keyStatusText}</p>
        </div>
    </>);
};

export const Promoters = ({access, list, cities}) => {

    const [promoterIdPopup, setPromoterIdPopup] = useState('');
    const [city, setCity] = useState(getStorageData(cities, ADVERT_CITY_STORAGE_NAME));
    const setCityHandler = createHandlerWithStorage(setCity, ADVERT_CITY_STORAGE_NAME);
    const thisPromoter = promoterIdPopup === '' || promoterIdPopup === 'new'
    ? null : list.find(p => p._id === promoterIdPopup);

    const [showDeleted, setShowDeleted] = useState(false);
    const [searchVal, setSearchVal] = useState('');
    const displayList = [...list].sort((a, b) => a.id - b.id).filter((p) => p.deleted === showDeleted && p.city._id === city && p.fullname.toLowerCase().includes(searchVal.toLowerCase()));

    if (!access) {
        return <EmptyPage message='Нет доступа к информации промоутеров' />
    }
    return (
        <div className="promoters">
            <div className="container">
                <div className="promoters__header" style={{columnGap: '16px'}}>
                    <div className="promoters__select-city">
                        <Select enums={cities} value={city} changeHandler={(e) => setCityHandler(e.target.value)} />
                    </div>
                    <div className="users__search">
                        <Input style={{padding: '4px'}} placeholder='поиск' value={searchVal} changeHandler={(e) => setSearchVal(e.target.value)} />
                    </div>
                    {!showDeleted && <div className="users__deleted-button button" onClick={() => setShowDeleted(true)}>
                        <Bin width={19} height={19}/>
                        удаленные промы
                    </div>}
                    {showDeleted && <Button text='← к активным промам' style={{marginLeft: 'auto'}} onClick={() => setShowDeleted(false)}/>}
                </div>
                <div className="promoters__list">
                    {!showDeleted && <div className="promoters__item promoter-item dark-theme-bg0-hover-bg1 promoter-item-create" onClick={() => setPromoterIdPopup('new')}>
                        <p>+ Новый промоутер</p>
                    </div>}
                    {displayList.map(p => <PromoterItem key={p._id} data={p} setEditPromoterPopup={() => setPromoterIdPopup(p._id)} />)}
                </div>
            </div>
            {promoterIdPopup && <CreatePromoter closeFn={() => setPromoterIdPopup('')} curPromoter={thisPromoter} />}
        </div>
    );
};
